import React from 'react';

import { Path, useFormContext } from 'react-hook-form';

import { ReadOnlyInput } from '@infoods/lifebase-ui';
import { GridTableCell } from '../../../../../shared/components/table-components';
import { Nutrient } from '../../../../../shared/components/ui-components';
import { NutrientType } from '../../../../../shared/constants/NUTRIENTS_ENUM';

import { MealPlansMacrosFormValues } from '../../../../interfaces/MealPlan';

type NutrientInfoGroupProps = {
  label: string;
  name: Path<MealPlansMacrosFormValues>;
  nutrient: NutrientType;
};

const NutrientInfoGroup = ({ label, nutrient, name }: NutrientInfoGroupProps) => {
  const { control } = useFormContext<MealPlansMacrosFormValues>();

  return (
    <>
      <GridTableCell variant="title">{label}</GridTableCell>
      <GridTableCell>
        <Nutrient nutrient={nutrient}>
          <ReadOnlyInput control={control} name={name} />
        </Nutrient>
      </GridTableCell>
    </>
  );
};

export { NutrientInfoGroup, type NutrientInfoGroupProps };
